import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet';
import { SingleTextInput } from './ProductFormComponent';
import DropdownSelect from './DropdownSelect';

const HybridInputSelect = ({
  small,
  value,
  handleFormValues,
  options = null,
  inputProps = {},
  dropdownProps = {},
  searchable = false,
  ...rest
}) => {
  const onDropdownSelect = (selected) => {
    handleFormValues(selected);
  };

  const onInputChange = (inputValue) => {
    handleFormValues(inputValue);
  };

  const showOptions = Boolean(
    options?.length > 0 || dropdownProps.inputConfig?.overrideOptions?.length > 0,
  );

  return (
    <Box direction="column" gap="1rem" {...rest}>
      <SingleTextInput
        focusHighlight="var(--page-focus-highlight)"
        value={value}
        handleFormValues={onInputChange}
        {...inputProps}
      />
      {showOptions && (
        <Box width={small ? '75%' : '60%'}>
          <DropdownSelect
            selectable
            small={small}
            simpleOptions={options}
            handleFormValues={onDropdownSelect}
            label="Select from options"
            value={null}
            autoSelect={false}
            searchable={searchable}
            inputConfig={dropdownProps?.inputConfig}
            {...dropdownProps}
          />
        </Box>
      )}
    </Box>
  );
};

HybridInputSelect.propTypes = {
  small: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleFormValues: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  overrideOptions: PropTypes.arrayOf(PropTypes.shape({
    api: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
  })),
  inputProps: PropTypes.object,
  dropdownProps: PropTypes.object,
  searchable: PropTypes.bool,
};

export default HybridInputSelect;
